import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { useDevPanelContext } from '../../DevPanel/context/DevPanelContext';
import { useCanCreateGoals } from 'modules/missionControl/hooks/useCanCreateGoals';

export const useGoalsDashboardState = () => {
  const {
    userGoalsQuery: { goals, isLoading: isUserGoalsLoading, hasError: isUserGoalsError },
    projectGoalsQuery: { total: totalProjectGoals = 0, isLoading: isProjectGoalsLoading },
    missionControlUserPreferencesQuery: { isLoading: isMissionControlUserPreferencesLoading },
  } = useMissionControlContext();

  const canCreateGoals = useCanCreateGoals();

  const isEmpty = !isUserGoalsLoading && !isUserGoalsError && goals.length === 0;
  const hasData = goals.length > 0;
  const hasGoalsInProject = totalProjectGoals > 0;

  const {
    devToolGoalsStates: {
      isDevToolLoadingStateEnabled,
      isDevToolErrorStateEnabled,
      isDevToolEmptyStateEnabled,
      isDevToolDataStateEnabled,
    },
  } = useDevPanelContext();

  const isLoadingState =
    isDevToolLoadingStateEnabled ||
    isUserGoalsLoading ||
    isProjectGoalsLoading ||
    isMissionControlUserPreferencesLoading;
  const isErrorState = isDevToolErrorStateEnabled || isUserGoalsError;
  const isEmptyState = isDevToolEmptyStateEnabled || isEmpty;
  const isDataState = isDevToolDataStateEnabled || hasData;

  return {
    isLoadingState,
    isErrorState,
    isEmptyState,
    isDataState,
    hasGoalsInProject,
    canCreateGoals,
  };
};
